<template>
  <nav class="navbar navbar-expand-lg transparent-navbar">
    <div class="container">
      <router-link to="/" class="navbar-brand">
        <img src="/images/logo/intek-electronic-logo.png" alt="Logo" class="logo" />
      </router-link>

      <button
        class="navbar-toggler"
        type="button"
        @click="mobileMenuOpen = !mobileMenuOpen"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div
        class="collapse navbar-collapse"
        :class="{ show: mobileMenuOpen }"
      >
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/">ANASAYFA</router-link>
          </li>

          <!-- Kurumsal Dropdown -->
          <li
            class="nav-item dropdown"
            @mouseenter="openDropdown('kurumsal')"
            @mouseleave="closeDropdown('kurumsal')"
            :class="{ show: dropdowns.kurumsal }"
          >
          <span class="nav-link dropdown-toggle" style="cursor:pointer; display: inline-block; padding: 15px 0px;">KURUMSAL</span>
            <ul class="dropdown-menu" :class="{ show: dropdowns.kurumsal }">
              <li><router-link class="dropdown-item" to="/hakkimizda">Biz Kimiz</router-link></li>
              <li><router-link class="dropdown-item" to="/degerler">Değerlerimiz</router-link></li>
              <li><router-link class="dropdown-item" to="/ne-yapiyoruz">Ne Yapıyoruz</router-link></li>
              <li><router-link class="dropdown-item" to="/kalite-politikamiz">Kalite Politikamız</router-link></li>
              <li><router-link class="dropdown-item" to="/">Sertifikalarımız</router-link></li>
              <li><router-link class="dropdown-item" to="/haberler">Haberler</router-link></li>
            </ul>
          </li>

          <!-- Hizmetler Dropdown -->
         <li class="nav-item dropdown"
    @mouseenter="openDropdown('hizmetler')"
    @mouseleave="closeDropdown('hizmetler')"
    :class="{ show: dropdowns.hizmetler }"
>
  <span class="nav-link dropdown-toggle" style="cursor:pointer; display: inline-block; padding: 15px 0px;">HİZMETLERİMİZ</span>
  <ul class="dropdown-menu" :class="{ show: dropdowns.hizmetler }">
    <li><router-link class="dropdown-item" :to="{ path: '/hizmetler', hash: '#arge' }">ARGE</router-link></li>
    <li><router-link class="dropdown-item" :to="{ path: '/hizmetler', hash: '#tasarim' }">Tasarım</router-link></li>
    <li><router-link class="dropdown-item" :to="{ path: '/hizmetler', hash: '#numune-prototip' }">Numune & Prototip</router-link></li>
    <li><router-link class="dropdown-item" :to="{ path: '/hizmetler', hash: '#uretim' }">Üretim</router-link></li>
  </ul>
</li>

          <!-- Üretim Dropdown -->
          <li
            class="nav-item dropdown"
            @mouseenter="openDropdown('uretim')"
            @mouseleave="closeDropdown('uretim')"
            :class="{ show: dropdowns.uretim }"
          >
          <span class="nav-link dropdown-toggle" style="cursor:pointer; display: inline-block; padding: 15px 0px;">ÜRETİM</span>
            <ul class="dropdown-menu" :class="{ show: dropdowns.uretim }">
              <!-- <li><router-link class="dropdown-item" to="/otomasyon-sistemleri">Otomasyon Sistemleri</router-link></li> -->
              <li><router-link class="dropdown-item" to="/kumanda-kontrol-kartlari">Kumanda Kontrol Kartları</router-link></li>
              <li><router-link class="dropdown-item" to="/kablo-gruplama">Kablo Gruplama</router-link></li>
              <li><router-link class="dropdown-item" to="/sensor-uretimi">Sensör Üretimi</router-link></li>
              <li><router-link class="dropdown-item" to="/prototip-uretimi">Prototip Üretimi</router-link></li>
            </ul>
          </li>

          <li class="nav-item">
            <router-link class="nav-link" to="/arge">ARGE</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/iletisim">İLETİŞİM</router-link>
          </li>
          <!-- <li class="nav-item">
           <router-link to="/magaza" class="nav-link">ÜRÜNLER</router-link>
          </li> -->

          <!-- <li class="nav-item">
            <a
              class="nav-link online-btn"
              href="https://www.intekelectronics.com.tr"
              target="_blank"
            >
              <img src="/images/online-satis.png" class="online-logo" />Online Satış
            </a>
          </li> -->
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      mobileMenuOpen: false,
      dropdowns: {
        kurumsal: false,
        hizmetler: false,
        uretim: false
      }
    };
  },
  methods: {
    openDropdown(key) {
      this.dropdowns[key] = true;
    },
    closeDropdown(key) {
      this.dropdowns[key] = false;
    }
  }
};
</script>

<style scoped>
/* 
.transparent-navbar {
  position: relative; 
  width: 100%;
  z-index: 10;
  background: transparent;
} */
 .transparent-navbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 20; /* banner'ın üstünde olacak */
  /* background: rgba(109, 107, 107, 0.3); */
  background: transparent;
}

.logo {
  max-height: 100px;
}

.navbar-toggler {
  border-color: rgba(255,255,255,0.6);
}

.navbar-toggler-icon {
  filter: invert(1);
}

.nav-link {
  color: #fff !important;
  font-weight: 600;
  margin: 0 0.5rem;
  text-transform: uppercase;
}

.nav-link:hover {
  color: #0152c9 !important;
}

/* Dropdown */
.nav-item.dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  margin: 0;
  padding: 0.5rem 0;
  background: #fff;
  border: none;
  min-width: 12rem;
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.15);
}

.dropdown-menu.show {
  display: block;
}

.dropdown-item {
  padding: 0.5rem 1rem;
  color: #333;
  white-space: nowrap;
}

.dropdown-item:hover {
  background: #f5f5f5;
  color: #00bfff;
}

/* Mobile açıldığında collapse */
.collapse.show {
  background: rgba(0,0,0,0.8);
}
.online-btn {
  display: flex;
  align-items: center;
  color: #fff !important;
}
.online-logo {
  height: 20px;
  margin-right: 0.5rem;
}
@media (max-width: 992px) {
    ::v-deep(.navbar-nav .nav-link.dropdown-toggle) {
    padding: 8px 0px !important;
  }
  .navbar-nav .nav-link.dropdown-toggle {
    padding: 8px 0px !important;
    display: block;
  }

  .navbar-nav .dropdown-menu {
    padding: 0;
    margin: 0;
  }

  .navbar-nav .dropdown-item {
    padding: 8px 20px;
  }
}
</style>
